import GenerateAccessForm from './GenerateAccessForm';

export default GenerateAccessForm;
